import classNames from 'classnames'
import IconButton from 'components/common/iconButton/IconButton'
import { Chat } from 'components/types'
import { useState } from 'react'
import { CustomColorsRef, IconSizes } from 'types/general'

interface ChatsProps {
  chats: Chat[]
  selectedChat: Chat | null
  handleSelect: (chat: Chat) => void
}
const Chats = ({ chats, selectedChat, handleSelect }: ChatsProps) => {
  const [isHovered, setIsHovered] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0)

  return (
    <div className="w-[180px] border-r border-gray-300">
      <h2 className="text-lg font-semibold mb-2 p-2">Adicionar filtros</h2>
      <ul className="w-full">
        {chats.map((chat, index) => (
          <li
            key={chat.id}
            className={`w-full flex text-sm 
              items-center p-2 cursor-pointer border-b border-gray-200 ${
                selectedChat?.id === chat.id
                  ? 'bg-gray-200'
                  : 'hover:bg-gray-100'
              }`}
            onClick={() => handleSelect(chat)}
            onMouseEnter={() => {
              setIsHovered(true)
              setCurrentIndex(index)
            }}
            onMouseLeave={() => setIsHovered(false)}
          >
            <img
              src={chat.avatar}
              alt={chat.person}
              className="w-10 h-10 rounded-full mr-3"
            />
            <div className="flex-1 w-full">
              <div className="flex w-full justify-between items-center">
                <h3 className="font-semibold">{chat.person}</h3>
                <IconButton
                  icon="regular-ellipsis"
                  size={IconSizes.MD}
                  color={CustomColorsRef.Gray}
                  handleClick={() => alert('test')}
                  className={classNames(
                    'mr-12 my-0',
                    isHovered && index === currentIndex ? 'block' : 'hidden'
                  )}
                />
              </div>
              <p className=" w-2/3 text-xs text-gray-600 truncate">
                {chat.messages[chat.messages.length - 1].text}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Chats
